<app-page-layout [displayCustomerService]="false">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 col-md-offset-3">
        <mat-card>
          <mat-card-header>
            <mat-card-title class="center">
              {{ 'PASSWORD_RESET.NEW_PASSWORD_FOR' | translate:{arg:loginID} }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="row">
              @if (isLoading()) {
                <app-loading></app-loading>
              } @else {
                @if (hasBeenReset) {
                  <ng-container *ngTemplateOutlet="successMessage"></ng-container>
                } @else {
                  <ng-container *ngTemplateOutlet="errorMessage"></ng-container>
                  <form [formGroup]="form">
                    <mat-form-field class="col-md-12">
                      <mat-label>{{'COMMON.USER_NAME_PLACEHOLDER' | translate}}</mat-label>
                      <input matInput formControlName="loginID" type="text" name="first">
                      <mat-error>{{'VALIDATION.REQUIRED'|translate}}</mat-error>
                    </mat-form-field>
                    <div formGroupName="passwordGroup">
                      <mat-form-field class="col-md-12">
                        <mat-label>{{'REGISTRATION.STEP.ACCOUNT_CREATION.PASSWORD' | translate}}</mat-label>
                        <input name="password" matInput type="text" inputmode="numeric" maxlength="6" formControlName="password"
                          placeholder="Ex: 123456">
                        @if (form.get(['passwordGroup', 'password']).invalid) {
                          <mat-error>
                            {{ getPasswordError() | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field class="col-md-12">
                        <mat-label>{{'REGISTRATION.STEP.ACCOUNT_CREATION.CONFIRM_PASSWORD' | translate}}</mat-label>
                        <input matInput formControlName="confirmPassword" type="text" [errorStateMatcher]="matcher">
                        @if (form.get('passwordGroup.confirmPassword').hasError('required')) {
                          <mat-error>
                            {{ 'VALIDATION.REQUIRED' | translate }}
                          </mat-error>
                        }
                        @if (form.get('passwordGroup').hasError('childrenNotEqual')) {
                          <mat-error>
                            {{ 'REGISTRATION.FORM.CONFIRM_PASSWORD' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-md-12">
                      <button mat-raised-button color="primary" class="full-width"
                        [disabled]="isLoading() || form.invalid" (click)="submit()">
                        {{'COMMON.CONFIRM' | translate}}
                      </button>
                    </div>
                  </form>
                }
              }
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</app-page-layout>
<ng-template #errorMessage>
  @if (errorMatcher.isError()) {
    <div class="col-md-12">
      <div class="alert custom-danger text-left" role="alert">
        <p class="error">
          <mat-icon class="danger">error</mat-icon>
          @for (error of errorMatcher.logError; track error) {
            <span>{{error.message | translate:{arg:error.arg} }}</span>
          }
        </p>
      </div>
    </div>
  }
</ng-template>
<ng-template #successMessage>
  <div class="col-md-12">
    <div class="alert alert-success" role="alert">
      <span>{{'PASSWORD_RESET.RESET_SUCCESS' |translate }}</span>
      <p> {{'COMMON.GO_TO_LOGIN' | translate }}</p>
    </div>
  </div>
</ng-template>
